import { use, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import Header from "./Header";
import AdminSidebar from "./AdminSidebar";
import { Box } from "@mui/material";
import CustomLoader from "../component/loader/Loader";
import { useApi } from "../hooks";
import { apiGetUser, apiLogutUser, method } from "../apiPath";
import keyNames from "../keyName";
import { getToast } from "../common/utils";
const AdminLayout = () => {
  const hitApi = useApi();
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.mainReducer);
  const { userData } = storeData;
  const [open, setOpen] = useState(true);
  useEffect(() => {
    const toast = getToast("error");
    if (!sessionStorage.authToken && !userData) navigate("/");
    if (sessionStorage.authToken && !userData) {
      hitApi(apiGetUser, null, method.get, keyNames.userData, toast);
    }
    if (userData && userData.role !== "MASTER") {
      sessionStorage.removeItem("authToken");
      hitApi(apiLogutUser, null, method.post, keyNames.userData);
      // navigate("/");
      window.location.href = "/";
    }
  }, [navigate, userData]);

  return userData && userData.role === "MASTER" ? (
    <Box className="vh-100" sx={{ display: "flex" }}>
      <Header open={open} setOpen={setOpen} />
      <AdminSidebar open={open} />
      <Box
        className="transition"
        sx={{
          ml: open ? "240px" : "66px",
          mt: "64px",
          minHeight: "calc(-64px + 100vh)",
          width: "100%",
          borderRadius: "8px 8px 0px 0px",
          backgroundColor: (theme) => `${theme.palette.primary.main}10`,
          flexGrow: 1,
          p: 3,
          overflowY: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  ) : (
    <CustomLoader />
  );
};
export default AdminLayout;
